import moment from 'moment';
import { Spinner } from '@fluentui/react-components';
import { formatCurrencyAmountWithIssue } from '../../../commons/currency/Currency.Functions';
import { SettlementDebt } from "../../../models/Entities/SettlementDebt/SettlementDebt";
import { isDebtPaid } from './SettlementDebtsDetails.Summary';

interface SettlementDebtsInfoProps {
    SettlementDebts: SettlementDebt[];
}

const fmt = (amount: number, currency: string) => formatCurrencyAmountWithIssue(amount, currency);

/** Una fila por deuda: fecha, importe, estado y saldo. Sin detalle todavía, la fila espera. */
const SettlementDebtsInfoComponent = ({ SettlementDebts }: SettlementDebtsInfoProps) => {
    if (!SettlementDebts || SettlementDebts.length === 0) return null;

    return (
        <ul className="sdd-list">
            {SettlementDebts.map((settlementDebt) => {
                const debt = settlementDebt.CashFlowDebt;
                const key = `${settlementDebt.id}-${settlementDebt.debtId}`;

                if (!debt) {
                    return (
                        <li key={key} className="sdd-row sdd-row--loading">
                            <span className="sdd-row__dot" aria-hidden />
                            <span className="sdd-row__ref">Deuda #{settlementDebt.debtId}</span>
                            <span className="sdd-row__loading"><Spinner size="extra-tiny" /> Cargando detalle…</span>
                        </li>
                    );
                }

                const paid = isDebtPaid(settlementDebt);
                const currency = debt.currencyCode?.toUpperCase() || 'ARS';
                const originalCurrency = debt.originalCurrencyCode?.toUpperCase();
                const hasConversion = !!originalCurrency && originalCurrency !== currency && debt.originalAmountInOriginalCurrency != null;

                return (
                    <li key={key} className={`sdd-row${paid ? ' sdd-row--paid' : ' sdd-row--pending'}`}>
                        <span className="sdd-row__dot" aria-hidden />
                        <span className="sdd-row__ref">
                            <span className="sdd-row__id">#{debt.id}</span>
                            {debt.debtDate && <span className="sdd-row__date">{moment(debt.debtDate).format('DD/MM/YYYY')}</span>}
                        </span>
                        <span className="sdd-row__amount">
                            <span className="sdd-row__amount-main">{fmt(debt.originalAmount, currency)}</span>
                            {hasConversion && (
                                <span className="sdd-row__amount-original" title="Importe en la moneda original">
                                    {fmt(debt.originalAmountInOriginalCurrency, originalCurrency!)}
                                </span>
                            )}
                        </span>
                        <span className={`sdd-row__badge${paid ? ' sdd-row__badge--paid' : ' sdd-row__badge--pending'}`}>
                            {paid ? 'Pagada' : 'Pendiente'}
                        </span>
                        <span className="sdd-row__pending">
                            {paid ? <span className="sdd-row__zero">—</span> : fmt(debt.pendingAmount, currency)}
                        </span>
                    </li>
                );
            })}
        </ul>
    );
};

export default SettlementDebtsInfoComponent;
